/* eslint-disable no-alert */
import React from 'react';

import { AngleSvg, HeaderCtn, HeaderContent, HeroImg } from './index.style';
import brand from '../../../branding';

interface PageHeaderProps {
  children: React.ReactChild[];
  backgroundImg: string;
}

const PageHeader: React.FC<PageHeaderProps> = ({ children, backgroundImg }): React.ReactElement => {
  return (
    <HeaderCtn backgroundImg={backgroundImg}>
      <HeaderContent>{children}</HeaderContent>
      {brand.heroContain ? (
        <HeroImg src={backgroundImg} alt="" />
      ) : (
        <AngleSvg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100" preserveAspectRatio="none">
          <polygon points="0,0 0,100 100,100" />
        </AngleSvg>
      )}
    </HeaderCtn>
  );
};

export default PageHeader;
